import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '~local/environments/environment';

@Injectable()
export class NotificationTriggersService {
    private readonly triggersApiUrl: string;

    constructor(private http: HttpClient) {
        this.triggersApiUrl = environment.triggersApiUrl;
    }

    //
    // API Status
    //
    public getApiStatus(): Promise<any> {
        return this.http.get(`${this.triggersApiUrl}/health/check`).toPromise();
    }

    //
    // Recipients
    //

    public getRecipients(): Observable<any> {
        return this.http.get<any>(`${this.triggersApiUrl}/recipients/all`);
    }

    public addRecipient(item: any): Observable<any> {
        return this.http.post<any>(`${this.triggersApiUrl}/recipients`, item);
    }

    public updateRecipient(item: any): Observable<any> {
        return this.http.put<any>(`${this.triggersApiUrl}/recipient/${item.id}`, item);
    }

    public removeRecipient(item: any): Observable<boolean> {
        return this.http.delete<any>(`${this.triggersApiUrl}/recipient/${item.id}`);
    }

    //
    // Transports
    //

    public getTransports(): Observable<any> {
        return this.http.get<any>(`${this.triggersApiUrl}/transports/all`);
    }

    public addTransport(item: any): Observable<any> {
        return this.http.post<any>(`${this.triggersApiUrl}/transports`, item);
    }

    public updateTransport(item: any): Observable<any> {
        return this.http.put<any>(`${this.triggersApiUrl}/transport/${item.id}`, item);
    }

    public removeTransport(item: any): Observable<boolean> {
        return this.http.delete<any>(`${this.triggersApiUrl}/transport/${item.id}`);
    }

    //
    //
    // Delivery
    //

    public getDeliveries(): Observable<any> {
        return this.http.get<any>(`${this.triggersApiUrl}/deliveries/all`);
    }

    public addDelivery(item: any): Observable<any> {
        return this.http.post<any>(`${this.triggersApiUrl}/deliveries`, item);
    }

    public updateDelivery(item: any): Observable<any> {
        return this.http.put<any>(`${this.triggersApiUrl}/delivery/${item.id}`, item);
    }

    public removeDelivery(item: any): Observable<boolean> {
        return this.http.delete<any>(`${this.triggersApiUrl}/delivery/${item.id}`);
    }

    //
    // Event Groups
    //

    public getEventGroups(): Observable<any> {
        return this.http.get<any>(`${this.triggersApiUrl}/groups/all`);
    }

    public addEventGroup(item: any): Observable<any> {
        return this.http.post<any>(`${this.triggersApiUrl}/groups`, item);
    }

    public updateEventGroup(item: any): Observable<any> {
        return this.http.put<any>(`${this.triggersApiUrl}/group/${item.id}`, item);
    }

    public removeEventGroup(item: any): Observable<boolean> {
        return this.http.delete<any>(`${this.triggersApiUrl}/group/${item.id}`);
    }

    //
    // Events
    //

    public getEvents(): Observable<any> {
        return this.http.get<any>(`${this.triggersApiUrl}/events/all`);
    }

    public addEvent(item: any): Observable<any> {
        return this.http.post<any>(`${this.triggersApiUrl}/events`, item);
    }

    public updateEvent(item: any): Observable<any> {
        return this.http.put<any>(`${this.triggersApiUrl}/event/${item.id}`, item);
    }

    public removeEvent(item: any): Observable<boolean> {
        return this.http.delete<any>(`${this.triggersApiUrl}/event/${item.id}`);
    }

    //
    // Templates
    //

    public getTemplates(): Observable<any> {
        return this.http.get<any>(`${this.triggersApiUrl}/templates/all`);
    }

    public addTemplate(item: any): Observable<any> {
        return this.http.post<any>(`${this.triggersApiUrl}/templates`, item);
    }

    public updateTemplate(item: any): Observable<any> {
        return this.http.put<any>(`${this.triggersApiUrl}/template/${item.id}`, item);
    }

    public removeTemplate(item: any): Observable<boolean> {
        return this.http.delete<any>(`${this.triggersApiUrl}/template/${item.id}`);
    }

    //
    // Triggers
    //

    public getTriggers(): Observable<any> {
        return this.http.get<any>(`${this.triggersApiUrl}/triggers/all`);
    }

    public addTrigger(item: any): Observable<any> {
        return this.http.post<any>(`${this.triggersApiUrl}/triggers`, item);
    }

    public updateTrigger(item: any): Observable<any> {
        return this.http.put<any>(`${this.triggersApiUrl}/trigger/${item.id}`, item);
    }

    public removeTrigger(item: any): Observable<boolean> {
        return this.http.delete<any>(`${this.triggersApiUrl}/trigger/${item.id}`);
    }

    public async evaluateTrigger(item: any): Promise<any> {
        return this.http.post<any>(`${this.triggersApiUrl}/activation/evaluate`, item).toPromise();
    }
}
